import { render, staticRenderFns } from "./Gallery3.vue?vue&type=template&id=577dcb8b&scoped=true"
import script from "./Gallery3.vue?vue&type=script&lang=js"
export * from "./Gallery3.vue?vue&type=script&lang=js"
import style0 from "./Gallery3.vue?vue&type=style&index=0&id=577dcb8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577dcb8b",
  null
  
)

export default component.exports